import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';

import useCashGiftRecommended from './hooks/useCashGiftRecommended';

function PrepaidCard() {
    const data = useCashGiftRecommended();
    return (
        <Container fullWidth
            align='center'>
            <CardList spacing={12}
                fullWidth>
                {data?.items.map((item) => {
                    const { name, itemId, thumbnailUrl } = item;
                    return (
                        <Link activityParams={{ type: 'GIFT', giftItemId: itemId }}
                            activityName='PrepaidCardImagesActivity'>
                            <CardContainer key={itemId}
                                spacing={8}
                                align='center'>
                                <Card src={thumbnailUrl} />
                                <Text color={colors.gray6}>{name}</Text>
                            </CardContainer>
                        </Link>
                    );
                })}
            </CardList>
            {data?.title && (
                <Text size='xl' fontWeight='bold' color={colors.gray7}>
                    {data.title}
                </Text>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    margin-top: 32px;
`;

const CardList = styled(Row)`
    overflow-x: auto;
    scroll-padding: 0 20px;
    scroll-snap-type: x mandatory;
    padding: 0 20px 16px;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const CardContainer = styled(Column)`
    scroll-snap-align: start;
    scroll-snap-stop: always;
`;

const Card = styled(Image)`
    align-items: center;
    border-radius: 4px;
    display: flex;
    height: 48px;
    justify-content: center;
    width: 84px;
    object-fit: cover;
`;

export default PrepaidCard;
